'use strict';
import {woosmapInitFindYourStoreMenu} from 'woosmap';
import {initSlotCarousel} from '../productTileComponent/productTile';
import { getCookie } from '../util/common.js';

var isKeyboardUser = false;

class Menu {
    init () {
        woosmapInitFindYourStoreMenu();
        $('.js-menu-tab').on('click', selectMainCategory);
        $('.js-open-left-menu').on('click', openLeftMenu);
        $('.js-intMenu-svgIcon_close, .js-intMenu-overlay').on('click', closeMenu);
        $(window).on('resize', closeMenu);

        // Track keyboard vs touch/mouse interaction
        $(document).on('keydown.a11yTrack', function () { isKeyboardUser = true; });
        $(document).on('mousedown.a11yTrack touchstart.a11yTrack', function () { isKeyboardUser = false; });
    }
}

const selectMainCategory = function (e) {
    e.preventDefault();
    const selectedCategory = $(e.currentTarget).data('target');
    var currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + 500);
    var expiryDate = currentDate.toUTCString();

    document.cookie = 'catSelection=' + selectedCategory + ';path=/;expires=' + expiryDate;
    document.location.href = $(e.currentTarget).data('href');
};

const openLeftMenu = function () {
    $('.js-open-left-menu').attr('aria-expanded', 'true');
    $('.js-intMenu-overlay').fadeIn();
    $('html').addClass('cc-menu-isOpen');
    $('.js-plp-refineBar').addClass('z-0');
    $('.js-intMenu-top').addClass('cc-open-close-container');

    /* Account Profile text to be copied in Mobile Menu from Header */
    if ($('.js-profileText').length > 0 && ($('.js-profileText-header') && $('.js-profileText-header').length > 0)) {
        appendHtml('.js-profileText', $('.js-profileText-header')[0]);
    }

    let categorySelected = $('.js-intMenu').data('menu-header-tab-id');
    $('.js-intMenu-category-block').removeClass('js-intMenu-category-block_active');
    let categoryBlockActive = $('.js-intMenu-category-block[data-category-content-id=' + categorySelected + ']').addClass('js-intMenu-category-block_active');
    appendHtml(categoryBlockActive, $('.categoriesMasterMenu-firstLvlCat[data-id-categ=' + categorySelected + ']'));
    $(categoryBlockActive).append($('.js-categoriesMasterMenu-container').find('.js-intMenu-footer')[0].outerHTML);

    if (Foundation.MediaQuery.atLeast('large')) {
        $('.js-intMenu-category-container, .js-intMenu-subCategory-container, .fnMenu-subSubCategory').css({ left: 0 });
    } else {
        $('.js-intMenu-category-container').css({ left: 0 });
    }

    $('.js-open-firstLvlCat').on('click', openFirstLevelCategory);
    $('.js-intMenu-switchGender-link').on('click', switchGender);
    bindKeyboardNavigation();

    // Focus the first focusable element in the menu after opening (keyboard only)
    if (isKeyboardUser) {
        setTimeout(function () {
            var $firstLink = $('.js-intMenu-category-block_active').find('a, button').filter(':visible').first();
            if ($firstLink.length) {
                $firstLink.focus();
            }
        }, 100);
    }
};

const openFirstLevelCategory = function (e) {
    e.preventDefault();
    let subCat = $(this);

    $('.js-open-firstLvlCat').removeClass('active');
    $(subCat).addClass('active');

    // Update aria-expanded on all expandable triggers
    $('.js-open-firstLvlCat[role="button"]').attr('aria-expanded', 'false');
    if (subCat.attr('role') === 'button') {
        subCat.attr('aria-expanded', 'true');
    }

    if (subCat.data('href')) {
        let subCatID = subCat.data('categoryId');
        let subCatBlock = $(
            '.' + subCatID + '.js-intMenu-subCategory-content'
        )[0];

        $('.js-intMenu-subCategory-container').removeClass('d-none');
        appendHtml('.js-intMenu-subCategory', subCatBlock);

        if (Foundation.MediaQuery.atLeast('large')) {
            // Check if content asset for specific category is present
            if ($('.cc-intCat-menuImage[data-subcategory-id=' + subCatID + ']').length > 0) {
                appendHtml('.js-intMenu-thirdLevel', $('.categoriesMasterMenu-thirdLvlCat .cc-intCat-menuImage[data-subcategory-id=' + subCatID + ']'));
                $('.js-intMenu-thirdLevel-container').removeClass('d-none').css({ left: parseInt($('.js-intMenu-subCategory-container').width() + $('.js-intMenu-category-container').width()) });
            } else if ($('.cc-intCat-trendingCategory[data-subcategory-id=' + subCatID + ']').children().length > 0) {
                // Otherwise make trending product cards appear
                appendHtml('.js-intMenu-thirdLevel', $('.categoriesMasterMenu-thirdLvlCat .cc-intCat-trendingCategory[data-subcategory-id=' + subCatID + ']'));
                $('.js-intMenu-thirdLevel-container').removeClass('d-none').css({ left: parseInt($('.js-intMenu-subCategory-container').width() + $('.js-intMenu-category-container').width()) });
            } else {
                // If neither is available, the third column collapses
                $('.js-intMenu-thirdLevel-container').css({ left: $('.js-intMenu-category-container').width() });
            }

            $('.js-intMenu-subCategory-container').css({ left: $('.js-intMenu-category-container').width() });
        } else {
            $('.js-intMenu-subCategory .js-intMenu-svgIcon_close').one('click', closeMenu);
            setTimeout(() => {
                $('.js-intMenu-subCategory-container').css({ left: 0 });
                $('.js-intMenu-category-container').css({ left: '-' + parseInt($('.js-intMenu-category-container').width()) + 'px' });
            }, 150);

            // Check if content asset for specific category is present
            if ($('.cc-intCat-menuImage[data-subcategory-id=' + subCatID + ']').length > 0) {
                appendHtml('.js-intMenu-subCategory-thirdColumn', $('.categoriesMasterMenu-thirdLvlCat .cc-intCat-menuImage[data-subcategory-id=' + subCatID + ']'));
            } else if ($('.cc-intCat-trendingCategory[data-subcategory-id=' + subCatID + ']').children().length > 0) {
                // Otherwise make trending product cards appear
                appendHtml('.js-intMenu-subCategory-thirdColumn', $('.categoriesMasterMenu-thirdLvlCat .cc-intCat-trendingCategory[data-subcategory-id=' + subCatID + ']'));
                initSlotCarousel('.js-intMenu-subCategory-thirdColumn');
            } else {
                // If neither is available, the third column collapses
                $('.js-intMenu-subCategory-thirdColumn').empty();
            }
        }
        $('.js-intMenu-subCategory-name').on('click', goBacktoFirstLevelCategories);

        // Focus the first link in the sub-menu (keyboard only)
        if (isKeyboardUser) {
            setTimeout(function () {
                var $firstSubLink = $('.js-intMenu-subCategory').find('a').filter(':visible').first();
                if ($firstSubLink.length) {
                    $firstSubLink.focus();
                }
            }, 200);
        }
    }
};

const goBacktoFirstLevelCategories = function () {
    $('.js-intMenu-category-container').css({ left: 0 });
    $('.js-intMenu-subCategory-container').css({ left: '100%' });

    // Reset aria-expanded and return focus to the previously active trigger (keyboard only)
    $('.js-open-firstLvlCat[role="button"]').attr('aria-expanded', 'false');
    if (isKeyboardUser) {
        var $activeTrigger = $('.js-open-firstLvlCat.active');
        if ($activeTrigger.length) {
            setTimeout(function () { $activeTrigger.focus(); }, 200);
        }
    }

    $('.js-open-firstLvlCat').on('click', openFirstLevelCategory);
};

const switchGender = function (e) {
    e.preventDefault();
    let topLevelCat = $(this);
    let topLevelCatActive = $(topLevelCat).hasClass('cc-intMenu-switchGender-link-isActive');

    $('.js-intMenu-switchGender-link').removeClass('cc-intMenu-switchGender-link-isActive');
    $(topLevelCat).addClass('cc-intMenu-switchGender-link-isActive');

    if (topLevelCat.data('target') && !topLevelCatActive) {
        let topLevelCatID = topLevelCat.data('target');
        let block = $('.js-intMenu-category-block[data-category-content-id=' + topLevelCatID + ']');

        if (block.children().length === 0) {
            appendHtml(block, $('.categoriesMasterMenu-firstLvlCat[data-id-categ=' + topLevelCatID + ']'));
            block.append($('.js-categoriesMasterMenu-container').find('.js-intMenu-footer')[0].outerHTML);
        }
        var currentDate = new Date();
        currentDate.setDate(currentDate.getDate() + 500);
        var expiryDate = currentDate.toUTCString();

        document.cookie = 'catSelection=' + topLevelCatID + ';path=/;expires=' + expiryDate;

        $('.js-open-firstLvlCat').on('click', openFirstLevelCategory);

        $('.js-intMenu-category-block')
            .show()
            .toggleClass('js-intMenu-category-block_active cc-intMenu-category-block_active')
            .on('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function () {
                $('.js-intMenu-category-block:not(.js-intMenu-category-block_active)').hide();
                $('.js-intMenu-category-block').off('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd');
            });
    } else {
        let topLevelCatID = topLevelCat.data('target');
        let varUrl = $('#Home_' + topLevelCatID).attr('value');
        location.href = varUrl;
        var currentDate = new Date();
        currentDate.setDate(currentDate.getDate() + 500);
        var expiryDate = currentDate.toUTCString();

        document.cookie = 'catSelection=' + topLevelCatID + ';path=/;expires=' + expiryDate;
    }
};

const closeMenu = function () {
    let allCategoryColumns = $('.js-intMenu-subCategory-container, .js-intMenu-category-container, .js-intMenu-thirdLevel-container');
    var categoryId = ($('.js-intMenu').data('menu-header-tab-id') !== undefined) ? $('.js-intMenu').data('menu-header-tab-id') : getCookie('catSelection');
    var currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + 500);
    var expiryDate = currentDate.toUTCString();
    $('.js-intMenu-top').removeClass('cc-open-close-container');

    // Reset ARIA states
    $('.js-open-left-menu').attr('aria-expanded', 'false');
    $('.js-open-firstLvlCat[role="button"]').attr('aria-expanded', 'false');

    // Return focus to hamburger button (keyboard only)
    if (isKeyboardUser) {
        setTimeout(function () { $('.js-open-left-menu').focus(); }, 100);
    }

    document.cookie = 'catSelection=' + categoryId + ';path=/;expires=' + expiryDate;
    $('.js-intMenu-overlay').fadeOut();
    $('html').removeClass('cc-menu-isOpen');
    $('.js-plp-refineBar').removeClass('z-0');
    $('.js-open-firstLvlCat').removeClass('active');

    if (Foundation.MediaQuery.atLeast('large')) {
        $(allCategoryColumns).css({ left: '' });
    } else {
        if (parseInt($('.js-intMenu-subCategory-container').css('left')) === 0) {
            $('.js-intMenu-category-container').addClass('cc-removeTransition').css({ left: 0 });
        }

        $(allCategoryColumns)
            .css({ left: '100%' })
            .on('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function () {
                $('.js-intMenu-switchGender-link').removeClass('cc-intMenu-switchGender-link-isActive');
                $('.js-intMenu-switchGender-link[data-target=' + $('.js-intMenu').data('menu-header-tab-id') + ']').addClass('cc-intMenu-switchGender-link-isActive');
                $('.js-intMenu-category-block').removeClass('js-intMenu-category-block_active cc-intMenu-category-block_active').show();
                $('.js-intMenu-category-block[data-category-content-id=' + $('.js-intMenu').data('menu-header-tab-id') + ']').addClass('js-intMenu-category-block_active cc-intMenu-category-block_active');
                $('.js-intMenu-category-container').removeClass('cc-removeTransition');
                $(allCategoryColumns).off('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd');
            });
    }

    $('.js-open-firstLvlCat').off('click');
    $('.js-intMenu-switchGender-link').off('click');
    unbindKeyboardNavigation();
};

/**
 * Keyboard navigation handler for menu accessibility.
 * Supports Enter/Space to activate items and Escape to close/go back.
 */
const handleMenuKeydown = function (e) {
    const key = e.which || e.keyCode;
    const ENTER = 13;
    const SPACE = 32;
    const ESCAPE = 27;

    if (key === ESCAPE) {
        e.preventDefault();
        // If sub-menu is open (mobile: left=0), go back; otherwise close entire menu
        var subMenuOpen = parseInt($('.js-intMenu-subCategory-container').css('left')) === 0;
        if (subMenuOpen && !Foundation.MediaQuery.atLeast('large')) {
            goBacktoFirstLevelCategories();
        } else {
            closeMenu();
        }
        return;
    }

    // Enter/Space on expandable items triggers click (opens sub-menu)
    if (key === ENTER || key === SPACE) {
        var $target = $(e.target);
        if ($target.hasClass('js-open-firstLvlCat') || $target.attr('role') === 'button') {
            e.preventDefault();
            $target.trigger('click');
        }
    }
};

const bindKeyboardNavigation = function () {
    $('.js-intMenu').off('keydown.a11y').on('keydown.a11y', handleMenuKeydown);
};

const unbindKeyboardNavigation = function () {
    $('.js-intMenu').off('keydown.a11y');
};

const appendHtml = function (putIn, getIn) {
    var getHtml = $(getIn)[0].outerHTML;
    var putHtml = $(putIn);
    putHtml.empty().append(getHtml);
};

const mainMenu = new Menu();
export default mainMenu;
